import React, { useState } from "react";
import { Html } from "@react-three/drei";
// useMediaQuery removed — was unused import

const Hotspot = React.memo(function Hotspot({
  hotspot,
  index,
  onHotspotClick,
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();

    if (hotspot.description && hotspot.description.trim()) {
      setShowTooltip(!showTooltip);
    }

    if (onHotspotClick) {
      onHotspotClick(hotspot);
    }

    if (hotspot.onClick) {
      hotspot.onClick();
    }
  };

  return (
    <group position={hotspot.position || [0, 0, 0]}>
      <Html center zIndexRange={[10, 0]}>
        <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {/* Unified Hotspot Marker */}
          <div
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              width: 24,
              height: 24,
              background: hotspot.color || "rgba(25, 118, 210, 0.9)",
              border: "2px solid white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: 10,
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.5)",
              transition: "all 0.2s ease",
              transform: isHovered ? "scale(1.2)" : "scale(1)",
              zIndex: 10,
            }}
          >
            {index + 1}
          </div>

          {/* Unified Description Tooltip */}
          {showTooltip && (hotspot.title || hotspot.description) && (
            <div
              style={{
                position: "absolute",
                left: "28px", // Offset to the right
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(0, 0, 0, 0.9)",
                color: "white",
                padding: "4px 8px",
                borderRadius: "8px",
                minWidth: "80px",
                maxWidth: "80px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
                border: "1px solid rgba(255,255,255,0.2)",
                backdropFilter: "blur(4px)",
                zIndex: 1000,
                pointerEvents: "none",
                userSelect: "none",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  borderBottom: "1px solid rgba(255,255,255,0.1)",
                  paddingBottom: 4,
                  marginBottom: 4,
                  fontSize: "12px",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                {hotspot.title || hotspot.label || `Hotspot ${index + 1}`}
              </div>
              {hotspot.description && (
                <div style={{ fontSize: "10px", opacity: 0.9, lineHeight: 1.4, overflowWrap: "break-word", wordBreak: "break-word" }}>
                  {hotspot.description}
                </div>
              )}
            </div>
          )}
        </div>
      </Html>
    </group>
  );
});

export default Hotspot;
